"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _getFit = require("../../utils/getFit");

var _reactI18next = require("react-i18next");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var DiagnosticFitItem = function DiagnosticFitItem(_ref) {
  var name = _ref.name,
      fit = _ref.fit,
      namespace = _ref.namespace,
      _ref$empty = _ref.empty,
      empty = _ref$empty === void 0 ? false : _ref$empty,
      itemMissingInJoboffer = _ref.itemMissingInJoboffer,
      itemMissingInProfile = _ref.itemMissingInProfile,
      bcValue = _ref.bcValue,
      pcValue = _ref.pcValue;
  var translateNs = namespace;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _styleModule.default.diagnosticItem,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography.default, {
      component: "div",
      className: _styleModule.default.diagnosticTitle,
      children: [t("".concat(translateNs, ".diagnostic.").concat(name, ".title")), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip.default, {
        size: "small",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: empty ? t("".concat(translateNs, ".diagnostic.empty.default")) : "".concat(parseInt(fit), "%")
        }),
        className: "".concat(_styleModule.default[(0, _getFit.getFit)(fit, itemMissingInProfile, itemMissingInJoboffer)], " ").concat(_styleModule.default.chip)
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      className: _styleModule.default.diagnosticText,
      children: (0, _getFit.fitDescriptionText)(fit, name, namespace, itemMissingInJoboffer, itemMissingInProfile, bcValue, pcValue, t)
    })]
  });
};

var _default = /*#__PURE__*/_react.default.memo(DiagnosticFitItem);

exports.default = _default;